// extracted by mini-css-extract-plugin
module.exports = {"popup":"Popup_popup_1Si47","content":"Popup_content_BrQC-"};